export { default as IndexTableCellTeamAvatar } from './IndexTableCellTeamAvatar';
